export default __webpack_public_path__ + "static/media/prev-earbuddyz.bec4a2c5.jpg";